import React from 'react';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import classNames from 'classnames'
import { images } from '../../../../assets/image';
import { Button } from '@material-ui/core';
import {
  ColorPalette,
} from 'screens/addEditCustomScreen/widgetsCardData/horizontalWidgetCard/types';

const VerticalWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const {
    widgetParams,
    defaultPaddings,
  } = props;

  const getColorPalette = () => {
    if (widgetParams.colorPalette === ColorPalette.ERROR) {
      return styles.widgetContainerErrorTheme;
    }

    if (widgetParams.colorPalette === ColorPalette.PRIMARY) {
      return styles.widgetContainerPrimaryTheme;
    }

    if (widgetParams.colorPalette === ColorPalette.SURFACE) {
      return styles.widgetContainerSurfaceTheme;
    }

    if (widgetParams.colorPalette === ColorPalette.CONTRAST) {
      return styles.widgetContainerContrastTheme;
    }
  }

  return (
    <div
      className={classNames([getColorPalette(), styles.verticalCard])}
      style={defaultPaddings}
    >
      <div className={styles.verticalCardHeader}>
        <img
          src={props.widgetParams.imageURL ? props.widgetParams.imageURL : images.placeHolder}
          className={classNames([styles.widgetImage])}
        />
        <p
          className={classNames([styles.widgetTitle])}
        >
          {widgetParams.title}
        </p>
      </div>
      <div className={styles.verticalCardBody}>
        <p
          className={classNames([styles.widgetDescription])}
          >
          {widgetParams.description}
        </p>
      </div>      
      <div
        className={classNames([styles.actionGroup , styles.verticalCardFooter])}
      >
        <Button
          className={classNames([styles.button])}
        >
          {widgetParams.actionButtonTitle}
        </Button>
        {
          `${widgetParams.dismissButton}` === 'true'
            ? (
              <Button
                className={classNames([styles.dismissButton])}
              >
                {'Dismiss'}
              </Button>
            ) : null
        }
      </div>
    </div>
  );
};

export default VerticalWidget;
